@if (title$ | async; as title) {
  @if (title) {
    <span class="context-title">{{ title }}</span>
  }
}

